var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
export default function MCLRowFormatter(props) {
    var rowClass = props.rowClass, rowData = props.rowData, cells = props.cells, rowProps = props.rowProps;
    return (React.createElement("div", __assign({ key: "row-".concat(rowData.rowState.i), className: rowClass }, rowProps), cells));
}
